<template>
  <div class="progress-bar">
    <!-- <div style="position: absolute; top: 0; right: 0">{{ seconds }}s</div> -->
    <p v-if="hasText" class="progress-bar__text">Загрузка...</p>
    <div class="progress-bar__bar">
      <div
        v-if="isInfinite"
        class="progress-bar__value progress-bar__value_infinite"
      />
      <div
        v-else
        class="progress-bar__value"
        :style="`width: ${progress * 100}%`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable vue/no-setup-props-destructure */
import { ref, watch } from 'vue';
import { useProgressAccum } from '~packages/progress-accum';

/*  */
const props = defineProps({
  hasText: {
    default: true,
    type: Boolean,
  },
  isInfinite: {
    type: Boolean,
  },
  needToStop: {
    type: Boolean,
  },
  rate: {
    default: 60,
    type: Number,
  },
  step: {
    default: 10 / 291,
    // default: 0.1,
    type: Number,
  },
  steps: {
    default: () => [
      [0.5, 0.35],
      [0.6, 1],
      [0.7, 2],
      [0.8, 4],
      [0.9, 5],
      [1, 7],
    ],
    type: Array<[number, number]>,
  },
  timeToStop: {
    default: 0.4,
    type: Number,
  },
  valueInitial: {
    default: 0,
    type: Number,
  },
});

const emit = defineEmits(['inited', 'stop']);

/* Technical. For debug */
const seconds = ref(0);
let int2: NodeJS.Timer | undefined = setInterval(() => ++seconds.value, 1000);

const onStop = () => {
  clearInterval(int2);
  int2 = undefined;
  emit('stop');
};

/*  */
const { progress, start, stop } = useProgressAccum(
  props.steps,
  props.step,
  props.rate,
  props.timeToStop,
  onStop,
  props.valueInitial
);

start();
emit('inited', progress);

watch(
  () => props.needToStop,
  () => {
    if (!props.needToStop) return;

    stop();
  },
  {
    immediate: true,
  }
);
</script>

<style lang="scss" scoped>
@import './ProgressBar';
</style>
